var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 43",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 21.4935,
    cy: 21.5,
    r: 20.4516,
    transform: "rotate(180 21.4935 21.5)",
    stroke: "currentColor",
    strokeWidth: 1
  })));
};
export default SvgCircle;